import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";

//bi fetched
export const fetchEinsurance = (payload) => {
  //console.log(payload)
  return {
    type: actionTypes.FETCH_EINSURANCE,
    formData: payload,
  };
};
// bi started
export const editEinsuranceStarted = () => {
  // //console.log(formData)
  return {
    type: actionTypes.FETCH_EINSURANCE_START,
  };
};

export const editEinsuranceSuccess = (formData) => {
  //console.log(formData);
  return {
    type: actionTypes.FETCH_EINSURANCE_SUCCESS,
    formData: formData,
    succMsg: "Proposal Updated Successfully",
  };
};

// export const fetchEinsuranceSuccess = (payload, apiPath) => {
//   return async (dispatch) => {
//     //console.log(payload);
//     dispatch(editEinsuranceStarted());
//     axiosRequest.put(apiPath, payload)
//     .then((res)=>{
//       //console.log(res)

//         //console.log(res?.elinsuranceAccountDetails);
//         dispatch(fetchEinsurance(res?.elinsuranceAccountDetails));
//     });

//   };
// };

export const fetchEinsuranceSuccess = (payload, apiPath) => {
  return async (dispatch) => {
    dispatch(editEinsuranceStarted());
    try {
      const res = await axiosRequest.put(apiPath, payload);
      dispatch(fetchEinsurance(res?.elinsuranceAccountDetails));
      return res;
    } catch (err) {
      console.error("Error in fetchEinsuranceSuccess:", err);
      throw err;
    }
  };
};

export const editEinsuranceFail = (errMsg) => {
  return {
    type: actionTypes.FETCH_EINSURANCE_FAIL,
    error: errMsg,
  };
};

export const clearEinsuranceData = () => {
  // //console.log(payload)
  return {
    type: actionTypes.CLEAR_STORE_EINSURANCE,
  };
};
